import { render, staticRenderFns } from "./HelpBannerImage.vue?vue&type=template&id=b868af4c"
import script from "./HelpBannerImage.vue?vue&type=script&lang=js"
export * from "./HelpBannerImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports